module.exports = __webpack_public_path__ + "img/eu.04da2a4b.svg";